/**
 * Diese Komponente bindet dann das jeweilige Modul ein, übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React, { useState, useEffect } from 'react'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension'

import { PostConfiguration } from '@professocial/professocialTypes/types'

// Post
import { postingRootReducer } from '@professocial/professocialPosting/src/store/postingRoot.reducer'
import { postingRootSagas } from '@professocial/professocialPosting/src/store/postingRoot.sagas'
import ProfessocialPost from '@professocial/professocialPosting/src/screens/ProfessocialPost'

interface IImportProfessocialNetworkContentProps {
  postConfiguration?: PostConfiguration
}

// NetworkContent
const sagaMiddleware = createSagaMiddleware()
const storePost = createStore(
  postingRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)
sagaMiddleware.run(postingRootSagas)

const ImportProfessocialPost: React.FC<IImportProfessocialNetworkContentProps> = (props) => {
  const [postConfiguration, setPostConfiguration] = useState<PostConfiguration>()

  useEffect(() => {
    setPostConfiguration(props.postConfiguration)
  }, [props.postConfiguration],
  )

  return (
    <Provider store={storePost}>
      <ProfessocialPost
        postConfiguration={postConfiguration}
      />
    </Provider>
  )
}
export default ImportProfessocialPost
